import { render, staticRenderFns } from "./RespChurchService.vue?vue&type=template&id=29148abf&"
import script from "./RespChurchService.vue?vue&type=script&lang=js&"
export * from "./RespChurchService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports